<!-- Unused file deprecated -->
<template>
  <div>{{ 'Component to create a category' }}</div>
</template>
